document.addEventListener('DOMContentLoaded', function() {
  var slideIndex = 0;
  var container = document.querySelector('.clients-slideshow-container');
  var slides = document.querySelectorAll('.client-slide');
  var totalSlides = slides.length;
  
  document.querySelector('.prev').addEventListener('click', function() {
    slideIndex--;
    if (slideIndex < 0) {
      slideIndex = totalSlides - 1;
    }
    updateSlidePosition();
  });

  document.querySelector('.next').addEventListener('click', function() {
    slideIndex++;
    if (slideIndex >= totalSlides) {
      slideIndex = 0;
    }
    updateSlidePosition();
  });

  function updateSlidePosition() {
    container.style.transform = 'translateX(' + (-slideIndex * 25) + '%)';
  }
});
